import { render, staticRenderFns } from "./IconInfoBulbFilled.vue?vue&type=template&id=0c8e0249&scoped=true"
import script from "./IconInfoBulbFilled.vue?vue&type=script&lang=js"
export * from "./IconInfoBulbFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e0249",
  null
  
)

export default component.exports